import { useState, useEffect } from 'react'

import { screenWidthBreakpoints } from 'styles/shared'

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth

      let size
      if (windowWidth < screenWidthBreakpoints.minMedium) {
        size = 'small'
      } else if (windowWidth <= screenWidthBreakpoints.maxMedium) {
        size = 'medium'
      } else {
        size = 'large'
      }

      setScreenSize(size)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return screenSize
}

export default useScreenSize
